import PropTypes from "prop-types";

const propTypes = {
  dovod: PropTypes.shape({
    I_DOVOD: PropTypes.number,
    N_DOVOD: PropTypes.string,
  }),
};

export default propTypes;
